<template>
  <div class="enter__body-form profile-form">
    <div class="enter__body-title">
      Войдите в профиль
    </div>

    <div class="subtitle">
      Чтобы копить баллы и получать персональные скидки
    </div>

    <form class="form" @submit.prevent="saveFormData">
      <TheInput
        label="Ваше имя"
        placeholder=""
        v-model:error="errors['firstname']"
        v-model="formData.firstname"
        type="text"
        required
      />

      <TheInput
        label="Номер телефона"
        placeholder=""
        :disabled="true"
        v-model:error="errors['telephone']"
        v-model="formData.telephone"
        type="text"
        required
      />

      <TheInput
        label="E-mail"
        placeholder=""
        v-model:error="errors['email']"
        v-model="formData.email"
        type="text"
        required
      />

      <TheInput
        label="Дата рождения"
        placeholder=""
        class_value="date"
        v-model="formData.custom_field['10']"
        type="date"
        required
      />

      <KpSelect
        v-model="formData.gender"
        v-model:error="errors['gender']"
        :options="genderOptions"
        label="Пол"
        required
        @input="(value) => { console.dir(value) }"
      />

      <div class="actions">
        <filled-button
          class="submit-button"
          type="submit"
          :disabled="isDisabledSubmit || !hasAcceptedPrivacy"
        >
          Сохранить данные
        </filled-button>

        <filled-button
          class="remind-later-button"
          @click="handleRemindLaterClick"
        >
          Напомнить позже
        </filled-button>
      </div>

      <div class="enter__body-personal">
        <KrdCheckbox v-model="hasAcceptedPrivacy">
          Предоставляя свои персональные данные, Вы соглашаетесь
          <!-- eslint-disable-next-line no-irregular-whitespace -->
          c <router-link :to="privacyRoute" target="_blank">условиями обработки персональных данных</router-link>
        </KrdCheckbox>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import UserSource from '@/api/UserSource.js'
import cookieStorage from "@/plugins/cookieStorage.js"

import TheInput from '@/components/form/TheInput.vue'
import KpSelect from '@/components/form/Select.vue'
import FilledButton from '@/components/element/buttons/Filled.vue'
import KrdCheckbox from '@/components/element/Checkbox.vue'

import { COOKIE_NAMES } from '@/configs/constants'

const DO_NOT_SHOW_MODAL_DAYS = 6
const GENDER_OPTIONS = [
  { id: 'male', name: 'Мужской' },
  { id: 'female', name: 'Женский' }
]

export default {
  name: 'ProfileForm',

  components: {
    TheInput,
    KpSelect,
    FilledButton,
    KrdCheckbox
  },

  data() {
    return {
      errors: {},
      formData: {
        custom_field: {
          10: ''
        }
      },
      genderOptions: GENDER_OPTIONS,
      hasAcceptedPrivacy: false
    }
  },

  computed: {
    ...mapState({
      userData: state => state.user.user,
    }),
    ...mapGetters({
      privacyRoute: 'city/privacyRoute',
    }),

    isDisabledSubmit() {
      return !this.formData.firstname ||
        !this.formData.email ||
        // !this.formData.telephone ||
        !this.formData.custom_field['10'] ||
        !this.formData.gender
    }
  },

  mounted() {
    this.initData()
  },

  methods: {
    ...mapActions('profileModal', ['setShowProfileModal']),
    ...mapMutations({
      'setUser': 'user/setUser',
    }),

    initData() {
      this.formData = {
        firstname: this.userData?.firstname,
        email: this.userData?.email,
        telephone: this.userData?.telephone,
        gender: this.userData?.gender,
        custom_field: {
          10: (this.userData?.custom_field || {})['10']
        }
      }
    },

    handleRemindLaterClick() {
      this.setShowProfileModal(false)
      cookieStorage.setItem(COOKIE_NAMES.pauseProfileModalWindow, true, DO_NOT_SHOW_MODAL_DAYS)
    },

    async saveFormData() {
      await this.$API.manager
        .getSource(UserSource)
        .saveProfile(this.formData)
        .then(({ customer }) => {
          this.setUser(customer)
          this.setShowProfileModal(false)
        }).catch((error) => {
          this.errors = error.response?.data?.errors
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-form {
  .subtitle {
    margin-top: 15px;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;

    @media (max-width: 650px) {
      font-size: 15px;
    }
  }

  .form {
    display: flex;
    flex-direction: column;

    & > * {
      margin-bottom: 15px;
    }

    .actions {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
    }

    .submit-button {
      margin-bottom: 10px;
    }

    .remind-later-button {
      background: #9a2b0b1f;
      color: #9a2b0b;

      &:hover {
        background: #9a2b0b30;
      }
    }
  }
}
</style>